<p>{{ modalViewProperties.message | translate }}</p>

<ziro-select [fieldId]="'documentType'"></ziro-select>

<ziro-file-uploader [fieldId]="'file'"></ziro-file-uploader>

<ng-template #errorTemplate>
  @if (isFormSubmitted && validationState === ValidationState.INVALID) {
    <span>
      {{ 'tkey;validators.global.required.missing.error' | translate }}
    </span>
  }
</ng-template>
